import {
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { CurrentUserService } from '@shared/services';

/**
 * Renders the template when the current user may mutate content for the given country
 * (Gstar/System Admin via canEditAnyCountry, or Country Admin for an assigned country).
 */
@Directive({
  standalone: false,
  selector: '[gstarCanEditCountry]',
})
export class CanEditCountryDirective {
  private readonly currentUserService = inject(CurrentUserService);
  private readonly templateRef = inject<TemplateRef<HTMLElement>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);

  readonly countryId = input<number | null | undefined>(undefined, {
    alias: 'gstarCanEditCountry',
  });

  constructor() {
    effect(() => {
      const countryId = this.countryId();
      // Re-evaluate when permissions signals change
      this.currentUserService.isCountryAdmin();
      this.currentUserService.countryAdminEditScope();
      this.currentUserService.canEditAnyCountry();
      this.currentUserService.isAdmin();

      this.viewContainer.clear();
      if (this.currentUserService.canEditCountry(countryId)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
